import React, { useState, useEffect } from 'react';
import './notice.css';
import { Link } from 'react-router-dom';
import { Navbar } from '../../../components/Navbar/Navbar';
import { Footer } from '../../../components/Footer/Footer';
import { Banner } from "../../../components/Banner/Banner";
import PLImage from '../../../assets/images/PolygonL.svg';
import PRImage from '../../../assets/images/PolygonR.svg';
import Plus from '../../../assets/images/plusNocircle.svg';

export const Notice = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    // --- [추가] 페이지네이션 상태 ---
    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 5; // 페이지당 게시물 수 (5개)

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            setIsAdmin(true);
        }

        const fetchPosts = async () => {
            try {
                const response = await fetch(`${BOARD_URL}/posts`);
                if (!response.ok) {
                    throw new Error('네트워크 응답이 올바르지 않습니다.');
                }
                const data = await response.json();
                // 최신순 정렬이 안되어 있다면 여기서 sort 가능. (보통 백엔드에서 주지만 확인 필요)
                // 예: data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setPosts(data);
            } catch (error) {
                console.error('게시물을 불러오는 데 실패했습니다:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("정말로 이 게시물을 삭제하시겠습니까?")) {
            try {
                const response = await fetch(`${BOARD_URL}/posts/${id}`, {
                    method: 'DELETE',
                    headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
                });

                if (response.ok) {
                    alert("삭제되었습니다.");
                    setPosts(posts.filter(post => post._id !== id));
                } else {
                    alert("삭제 실패");
                }
            } catch (error) {
                console.error("삭제 중 오류 발생:", error);
                alert("서버 오류로 삭제하지 못했습니다.");
            }
        }
    };

    // --- [추가] 페이지네이션 계산 로직 ---
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(posts.length / postsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <Banner title="공지사항" />
                <div className="notice-container">
                    <div className="notice-loading"><p>게시물을 불러오는 중입니다...</p></div>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <Banner title="공지사항" />

            <div className="notice-container">
                {/* 제목 행 */}
                <div className="notice-title">
                    <div className="notice-title-bot">
                        <div className="col no" style={{color:'646464',fontweight: '400'}}>No</div>
                        <div className="col titlee"style={{ width: '79.7vw', textAlign: 'center', fontWeight:'500', color:'646464' }}>제목</div>
                        <div className="col datee" style={{ width: '26vw', textAlign: 'center', color:'646464' }}>날짜</div>
                        {/* 관리자일 때 관리 컬럼 너비를 조금 더 확보 */}
                        {isAdmin && <div className="col manage" style={{ width: '19.2vw', textAlign: 'center' , color:'646464'}}>관리</div>}
                    </div>
                </div>

                {/* 공지 목록 */}
                <div className="notice-list">
                    {posts.length === 0 ? (
                        <div className="notice-loading"><p>게시물이 없습니다.</p></div>
                    ) : (
                        // posts.map 대신 currentPosts.map 사용
                        currentPosts.map((post, index) => (
                            <div className="notice-row" key={post._id}>
                                {/* 번호 계산: 전체 길이 - (현재페이지앞 게시물 수 + 현재인덱스) */}
                                <div className="col no">
                                    {posts.length - (indexOfFirstPost + index)}
                                </div>
                                <div className="col title">
                                    <Link to={`/notice/${post._id}`} className="notice-link">
                                        {post.title}
                                    </Link>
                                </div>
                                <div className="col date">
                                    {new Date(post.createdAt).toLocaleDateString()}
                                </div>

                                {/* 관리자 버튼 영역 (수정 / 삭제) */}
                                {isAdmin && (
                                    <div className="col-manage" >
                                        {/* --- [추가] 수정 버튼 --- */}
                                        <Link to={`/notice/noticeedit/${post._id}`} className="col modify">
                                            
                                                수정
                                            
                                        </Link>

                                        {/* 삭제 버튼 */}
                                        <div className="col delete" onClick={() => handleDelete(post._id)}
                                        >
                                            삭제
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))
                    )}
                </div>

                {/* --- [수정] 페이지 네비게이션 --- */}
                <div className="notice-movebar">
                    {/* 이전 페이지 화살표 */}
                    <img 
                        src={PLImage} 
                        alt="이전" 
                        className="arrow" 
                        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
                        style={{ 
                            cursor: currentPage > 1 ? 'pointer' : 'default', 
                            opacity: currentPage > 1 ? 1 : 0.3 
                        }}
                    />
                    
                    <div className="pages">
                        {/* 페이지 번호 생성 및 렌더링 */}
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
                            <span 
                                key={number}
                                className={`page-num ${currentPage === number ? 'active' : ''}`}
                                onClick={() => handlePageChange(number)}
                                style={{ cursor: 'pointer', margin: '0 0.5vw'}}
                            >
                                {number}
                            </span>
                        ))}
                    </div>

                    {/* 다음 페이지 화살표 */}
                    <img 
                        src={PRImage} 
                        alt="다음" 
                        className="arrow" 
                        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
                        style={{ 
                            cursor: currentPage < totalPages ? 'pointer' : 'default', 
                            opacity: currentPage < totalPages ? 0.7 : 0.3
                        }}
                    />
                </div>

                {/* 검색 & 글쓰기 */}
                <div className="notice-search">
                    {isAdmin ? (
                        <Link to="/notice/noticewrite" className="notice-admin">글쓰기
                        </Link>
                    ) : (
                        <div style={{ width: "9vw"}}></div>
                        
                    )}      
                </div>
            </div>

            <Footer />
        </>           
    );
};